import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'

const TweetLimitations = () => (
  <div className='br-upload-limitations'>
    <h4>MEDIA UPLOAD LIMITATIONS:</h4>

    <Tabs defaultActiveKey={1} id='media-upload-limitations'>
      <Tab eventKey={1} title='SUPPORTED FILES'>
        <ul>
          <li>
            <strong>Supported image media types:</strong> JPG, PNG, GIF, WEBP
          </li>
          <li>
            <strong>Supported video media types:</strong> MP4 or MOV
          </li>
        </ul>
      </Tab>
      <Tab eventKey={2} title='FILE SIZES & LENGTHS'>
        <ul>
          <li>
            <strong>Image file size:</strong> Must be less than 5 MB
          </li>
          <li>
            <strong>Animated GIF size:</strong> Must be less than 15 MB
          </li>
          <li>
            <strong>Video file size:</strong> Under 1GB strongly recommended for
            optimal performance.
          </li>
          <li>
            <strong>Video max time:</strong> 2 minutes and 20 seconds.
            <br />
          </li>
        </ul>
      </Tab>
      <Tab eventKey={3} title='MAXIMUM ATTACHMENTS'>
        <ul>
          <li>
            <strong>Tweet:</strong> 4 images, 1 animated GIF or 1 video
          </li>
          <li>
            <strong>DM:</strong> 1 image, 1 animated GIF or 1 video
          </li>
        </ul>
      </Tab>
    </Tabs>
  </div>
)

export default TweetLimitations



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/limitations/tweet.js